// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDDxW4IoaQrbwFRXegpKbkpHVhlObUUHjU",
  authDomain: "dil-tours.firebaseapp.com",
  projectId: "dil-tours",
  storageBucket: "dil-tours.firebasestorage.app",
  messagingSenderId: "799892861712",
  appId: "1:799892861712:web:b3bcf48f3d4028045aeb95",
  measurementId: "G-7ZGLDXQTJY"
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
